import { render, staticRenderFns } from "./AscGrayLabelBox.vue?vue&type=template&id=4f17a219&"
import script from "./AscGrayLabelBox.vue?vue&type=script&lang=js&"
export * from "./AscGrayLabelBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports